import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-salesquickview',
  templateUrl: './salesquickview.component.html',
  styleUrls: ['./salesquickview.component.css']
})
export class SalesquickviewComponent implements OnInit {

  @Input() salesid: any = 0;

  @Output() emitData = new EventEmitter();

  salesMainBO: any = {}
  salesDetailsColl: any = []
  salesChargesColl: any = []
  salesPayColl: any = []


  showProgress: boolean = false

  constructor(private appService: DhukanDataService, private datePipe: DatePipe, private activeModal: NgbActiveModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    public loginService: LoginDataService) { }

  ngOnInit() {
    this.fnGetSalesDetailsByQuickView()
  }


  fnGetSalesDetailsByQuickView() {
    try {
      this.fnShowProgress()

      var data = {
        'salesid': this.salesid
      }

      this.appService.getSalesDetailsByQuickView(data)
        .subscribe(
          (res) => {
            this.fnHideProgress()

            if (res.json().status === 200) {
              let result = res.json().result;

              if (result.length > 0) {
                if (result[0].length > 0) {
                  this.salesMainBO = result[0][0]
                }

                this.salesDetailsColl = result[1]
                this.salesChargesColl = result[2]
                this.salesPayColl = result[3]
              }

            } else if (res.json().status === 400) {
              this.toastr.error("Error", res.json().err_field)
            }
          },
          (err) => {
            this.fnHideProgress()
            this.toastr.error('Error', err);
          })
    } catch (ex) {
      this.fnHideProgress()
      this.fnShowErrorMsg(ex)
    }
  }



  fnRoundOff(_dvalue) {
    return Math.round(_dvalue).toFixed(2);
  }

  aaNumber(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number.parseFloat(Number(total).toFixed(2))
    }
  }


  fnViewEbill(){
    window.open('https://ebill.poswagon.com/'+this.salesMainBO.ssalesid, "_blank");    
  }


  public fnSetBtnClick() {
    var data = {

    }

    this.emitData.emit(data);
    this.activeModal.close(true);
  }


  public decline() {
    this.activeModal.close(false);
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}
